import script from "./InternalServiceDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalServiceDrawer.vue?vue&type=script&setup=true&lang=js"

import "./InternalServiceDrawer.vue?vue&type=style&index=0&id=7a588b31&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a588b31"]])

export default __exports__